/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { LuisId } from 'src/luis/types/Resource';

/**
 * The information needed for specifying the user's selection.
 */
export type SidePaneEntitySelection = {
    parentId?: LuisId;
    entityId?: LuisId;
    normalizedValue?: string;
    roleId?: LuisId;
};

export class SidePaneEntitySelectionStore {
    @observable
    public selection: SidePaneEntitySelection;

    constructor() {
        this.selection = {
            entityId: undefined,
            normalizedValue: undefined,
            parentId: undefined,
            roleId: undefined
        };
    }

    /**
     * Setter for the side pane entity selection.
     */
    @action
    public setSelection(selection: SidePaneEntitySelection) {
        this.selection = selection;
    }

    /**
     * Reset all the selection.
     */
    @action
    public resetSelection() {
        this.selection = {
            entityId: undefined,
            normalizedValue: undefined,
            parentId: undefined,
            roleId: undefined
        };
    }
}
